module.exports = __webpack_public_path__ + "img/rancher-logo.a24e2183.svg";